export default "__VITE_ASSET__BrYVon_r__"